
export interface SubscriptionPeriodGq {
  publicPeriodStart: string;
  publicPeriodEnd: string;

  monthlyCapSearchVolumeKw: number;
  monthlyUseSearchVolumeKw: number;

  monthlyCapRankKw: number;
  monthlyUseRankKw: number;

  monthlyCapTranslateKw: number;
  monthlyUseTranslateKw: number;

  monthlyCapChatGptDrafts: number;
  monthlyUseChatGptDrafts: number;

  monthlyCapProxyCalls: number;
  monthlyUseProxyCalls: number;
}

export const SubscriptionPeriodGqProps = `
  publicPeriodStart
  publicPeriodEnd

  monthlyCapSearchVolumeKw
  monthlyUseSearchVolumeKw

  monthlyCapRankKw
  monthlyUseRankKw

  monthlyCapTranslateKw
  monthlyUseTranslateKw

  monthlyCapChatGptDrafts
  monthlyUseChatGptDrafts
`;
